<template>
    <Modal class-name="scrollable vertical-center-modal" title="Nueva Evaluación: Confirmar usuarios" v-model="show" :footer-hide="true" :scrollable="true">

        <Loading v-if="loading" />

        <div v-else>
            <Alert type="warning">
                Revisa y confirma los usuarios que participarán en esta evaluación.
            </Alert>

            <List border size="small" style="margin-top: 20px; margin-bottom: 20px;">
                <template #header>
                    <h3 style="color: #843cf6">Área administrativa</h3>
                </template>
                <ListItem v-for="(g, i) in user_groups['Área directiva']" :key="`g-amdu-${i}`">
                    <div style="width: 100%; display: flex; flex-direction: column;">
                        <p style="color: black"><small>{{ g.role.name }}</small></p>
                        <h4>{{ g.name }}</h4>
                        <p style="color: grey; font-size: 90%">{{ g.email }}</p>
                    </div>
                </ListItem>
            </List>

            <List v-for="(program, i) in programs" :key="`g-pg-m-${i}`" border size="small" style="margin-bottom: 20px;">
                <template #header>
                    <h3 style="color: #843cf6">{{ program.name }}</h3>
                </template>
                <ListItem v-for="(g, j) in user_groups[program.name]" :key="`g-pg-m-up-${i}-${j}`">
                    <div style="width: 100%; display: flex; flex-direction: column;">
                        <p style="color: black"><small>{{ g.role.name }}</small></p>
                        <h4>{{ g.name }}</h4>
                        <p style="color: grey; font-size: 90%">{{ g.email }}</p>
                    </div>

                    <template #action>
                        <li v-if="g.role?.name !== 'Coordinación'">
                            <a href="#" @click="removeMember(program, g)">Eliminar</a>
                        </li>
                    </template>
                </ListItem>
                <template v-if="user_groups[program.name].length === 0">
                    <div style="padding: 20px">
                        <Alert type="error">
                            Este programa no cuenta con miembros activos.
                        </Alert>
                    </div>
                </template>
            </List>

            <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Crear evaluación</Button>
        </div>
    </Modal>
</template>

<script>
import Loading from "@/components/General/Loading.vue";

export default {
    components: {Loading},
    data(){
        return {
            show: false,
            evaluation: {
                name: "",
            },
            loading: true,
            programs: [],
            user_groups: [],
        }
    },
    methods: {
        save(){
            this.$Modal.confirm({
                title: 'Confirmar',
                content: `<p>¿Deseas crear la evaluación ${this.evaluation.name}?</p>`,
                okText: 'Crear',
                cancelText: 'Cancelar',
                onOk: () => {
                    window.axios.post(this.$root.API_URL + '/evaluation/usr/create', { ...this.evaluation })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('evaluations--add-evaluation', response.data.evaluation)
                                this.show = false
                                this.loading = false
                                this.clear()
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$Message.error('Hubo un problema, no pudimos completar esta acción');
                        })
                },
            });
        },
        getUsers(){
            window.axios.post(this.$root.API_URL + `/users/get`)
                .then(response => {
                    if( response.data.success ){
                        this.programs = response.data.programs
                        this.user_groups = response.data.users
                        this.loading = false
                    }
                })
        },
        removeMember(program, user){
            let ui = window._.findIndex(this.user_groups[program.name], u => u.id === user.id)
            if( ui !== -1 ){
                this.user_groups[program.name].splice(ui, 1)
            }
        }
    },
    mounted(){
        window.EventBus.$on('evaluations--create-popup--usrs', (year) => {
            this.getUsers()
            this.evaluation.name = year
            this.show = true
        })
    }
}
</script>
